
import PortfolioKpiHolisticPerformanceIndex from "@/components/PortfolioKpiHolisticPerformanceIndex";
import PortfolioKpiReturnValue from "@/components/PortfolioKpiReturnValue";
import PercentBox from "@/components/shared/PercentBox.vue";
import { privacyModeTextFormatterMixin } from '@/mixins';
import FormatterService from "@/service/FormatterService";

export default {
    name: 'ReturnValueKpiCard',
    components: {
        PercentBox,
        PortfolioKpiReturnValue,
        PortfolioKpiHolisticPerformanceIndex
    },

    mixins: [privacyModeTextFormatterMixin],

    props: {
        fromDate: {
            type: String,
            default: null,
        },
        roi: {
            type: Number,
            default: null,
        },
        roiRel: {
            type: Number,
            default: null,
        },
        holisticValue: {
            type: Number,
            default: null,
        },
        holistic: {
            type: Number,
            default: null,
        },
        currency: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            isHolisticMode: false,
            format: new FormatterService()
        }
    },

    computed: {
        percentText() {
            return this.isHolisticMode ?
                this.format.percent(this.holistic) :
                this.format.percent(this.roiRel)
        },
        currencyValue() {
            return this.isHolisticMode ?
                this.format.currency(this.holisticValue, this.currency, 'Totals') :
                this.format.currency(this.roi, this.currency, 'Totals');
        },
    },

    methods: {
        openReturnValuePopup() {
            this.$root.$emit('request-open-kpi-return-value-popup')
        },
        openKpiHolisticPerformancePopup() {
            this.$root.$emit('request-open-kpi-holistic-performance-index-popup')
        },
        handleOpenPopup() {
            if (this.isHolisticMode) {
                this.openKpiHolisticPerformancePopup();
            } else {
                this.openReturnValuePopup();
            }
        }
    }
}
